module.exports = __webpack_public_path__ + "static/media/ic-arrow-down-white.213e09bc.svg";